import { IAbsence } from '../Client/IAbsence'

export const GET_ABSENCES = 'GET_ABSENCES'
export const GET_ABSENCES_SUCCESS = 'GET_ABSENCES_SUCCESS'
export const GET_ABSENCES_FAILURE = 'GET_ABSENCES_FAILURE'

export const DELETE_ABSENCE = 'DELETE_ABSENCE'
export const DELETE_ABSENCE_SUCCESS = 'DELETE_ABSENCE_SUCCESS'
export const DELETE_ABSENCE_FAILURE = 'DELETE_ABSENCE_FAILURE'

export const UNDO_DELETE_ABSENCE = 'UNDO_DELETE_ABSENCE'
export const UNDO_DELETE_ABSENCE_SUCCESS = 'UNDO_DELETE_ABSENCE_SUCCESS'
export const UNDO_DELETE_ABSENCE_FAILURE = 'UNDO_DELETE_ABSENCE_FAILURE'

export const ADD_ABSENCE = 'ADD_ABSENCE'
export const ADD_ABSENCE_SUCCESS = 'ADD_ABSENCE_SUCCESS'
export const ADD_ABSENCE_FAILURE = 'ADD_ABSENCE_FAILURE'

export const UPDATE_ABSENCE = 'UPDATE_ABSENCE'
export const UPDATE_ABSENCE_SUCCESS = 'UPDATE_ABSENCE_SUCCESS'
export const UPDATE_ABSENCE_FAILURE = 'UPDATE_ABSENCE_FAILURE'

interface GetAbsencesAction {
  type: typeof GET_ABSENCES
}

interface GetAbsencesSuccessAction {
  type: typeof GET_ABSENCES_SUCCESS
  payload: {
    absences: IAbsence[]
  }
}

interface GetAbsencesFailureAction {
  type: typeof GET_ABSENCES_FAILURE
}

interface DeleteAbsenceAction {
  type: typeof DELETE_ABSENCE
}

interface DeleteAbsenceSuccessAction {
  type: typeof DELETE_ABSENCE_SUCCESS
  payload: {
    absence: IAbsence
  }
}

interface DeleteAbsenceFailureAction {
  type: typeof DELETE_ABSENCE_FAILURE
}

interface UndoDeleteAbsenceAction {
  type: typeof UNDO_DELETE_ABSENCE
}

interface UndoDeleteAbsenceSuccessAction {
  type: typeof UNDO_DELETE_ABSENCE_SUCCESS
  payload: {
    deletedAbsence: IAbsence
    absence: IAbsence
  }
}

interface UndoDeleteAbsenceFailureAction {
  type: typeof UNDO_DELETE_ABSENCE_FAILURE
}

interface UpdateAbsenceAction {
  type: typeof UPDATE_ABSENCE
}

interface UpdateAbsenceSuccessAction {
  type: typeof UPDATE_ABSENCE_SUCCESS
  payload: {
    absence: IAbsence
  }
}

interface UpdateAbsenceFailureAction {
  type: typeof UPDATE_ABSENCE_FAILURE
}

interface AddAbsenceAction {
  type: typeof ADD_ABSENCE
}

interface AddAbsenceSuccessAction {
  type: typeof ADD_ABSENCE_SUCCESS
  payload: {
    absence: IAbsence
  }
}

interface AddAbsenceFailureAction {
  type: typeof ADD_ABSENCE_FAILURE
  message: string
}

export type TActionTypes =
  | GetAbsencesAction
  | GetAbsencesSuccessAction
  | GetAbsencesFailureAction
  | DeleteAbsenceAction
  | DeleteAbsenceSuccessAction
  | DeleteAbsenceFailureAction
  | UndoDeleteAbsenceAction
  | UndoDeleteAbsenceSuccessAction
  | UndoDeleteAbsenceFailureAction
  | AddAbsenceAction
  | AddAbsenceSuccessAction
  | AddAbsenceFailureAction
  | UpdateAbsenceAction
  | UpdateAbsenceSuccessAction
  | UpdateAbsenceFailureAction
